// material-ui
import { Box, IconButton, Link, useMediaQuery } from '@mui/material';
import { GithubOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

// project import
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';
import TitleSection from './TitleSection';
import TitleSectionMobile from './TitleSectionMobile';
//import Cart from './Cart';
import Cookies from "js-cookie";
import LoginActionModal from 'core/components/login/LoginActionModal';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const {userprofileInfo} = useSelector((state)=>state.headerslice);
  const {message} = useSelector((state)=>state.headerslice);

  return (
    <>
      {/* {!matchesXs && <Search />} */}
      {/* {!matchesXs ? <TitleSection />: <TitleSectionMobile />} */}
      <TitleSection />
      

      
      {/* <Cart/> */}
      {/* <Notification /> */}
      {!matchesXs && <Profile />}
      {matchesXs && <MobileSection />}
      <LoginActionModal/>
    </>
  );
};

export default HeaderContent;